import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import { LoadingButton } from '../buttons/LoadingButton';
import { Box } from '@mui/material';

export const MatchWinnerSelector = ({
  team1Name,
  team2Name,
  value,
  handleChange,
  handleConfirm,
}) => {
  return (
    <Box py={4}>
      <Typography
        variant="overline"
        color="text.secondary"
        sx={{ fontSize: 18 }}
      >
        pick a winner
      </Typography>
      <Stack direction="row" alignItems="center">
        <RadioGroup
          value={value}
          onChange={handleChange}
          sx={{ width: '100%' }}
        >
          <FormControlLabel
            control={<Radio color="success" />}
            value={team1Name}
            label={team1Name}
          />
          <FormControlLabel
            control={<Radio color="success" />}
            value={team2Name}
            label={team2Name}
          />
        </RadioGroup>
        <LoadingButton
          fullWidth
          variant="outlined"
          color="success"
          disabled={!value}
          onClick={async () => handleConfirm('winner')}
          sx={{ height: 80, maxWidth: '50%' }}
        >
          Choose Winner
        </LoadingButton>
      </Stack>
    </Box>
  );
};
